import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-gateaux',
  templateUrl: './details-gateaux.component.html',
  styleUrls: ['./details-gateaux.component.css']
})
export class DetailsGateauxComponent implements OnInit {
  @Input() gout:string;
  @Input() tempsDePrep:number;
  @Input() valeurCalorique:number;

  modeAffichage = 'gout';

  changerModeAffichage(){
    this.modeAffichage = 'calories';

  }

  constructor() { }

  ngOnInit(): void {
  }

}
